// Orders API service using HATEOAS style
import { apiCall } from './apiService'

// Types that match the orders API response structure
export interface Order {
  id: string
  href: string
  patient_id: string
  patient_name?: string
  formulary_id: string
  formulary_name?: string
  medication_names?: string
  quantity: number
  directions?: string
  pharmacy_id: string
  pharmacy_name?: string
  status: 'pending' | 'processing' | 'shipped' | 'delivered' | 'cancelled'
  ship_to_patient: boolean
  refill: boolean
  order_date: string
  estimated_delivery?: string
  total_price?: number
  created_at: string
  updated_at: string
}

export interface OrdersListResponse {
  page_size: number
  page_number: number
  page_previous: string | null
  page_next: string | null
  total_items: number
  href: string
  items: Order[]
}

export interface OrdersQueryParams {
  status?: string[]
  patient_id?: string
  pharmacy_id?: string
  page_size?: number
  page_number?: number
  search?: string[]
}

export interface CreateOrderRequest {
  patient_id: string[]
  formulary_id: string
  quantity: number
  directions?: string
  pharmacy_id: string
  ship_to_patient: boolean
  refill: boolean
}

export const ordersApi = {
  // HATEOAS-style: Use the href from clinic.orders.href
  async getOrders(ordersHref: string, params?: OrdersQueryParams): Promise<OrdersListResponse> {
    // Build query params if provided
    let queryString = ''
    if (params) {
      const searchParams = new URLSearchParams()
      if (params.status) params.status.forEach(s => searchParams.append('status', s))
      if (params.patient_id) searchParams.set('patient_id', params.patient_id)
      if (params.pharmacy_id) searchParams.set('pharmacy_id', params.pharmacy_id)
      if (params.search) params.search.forEach(s => searchParams.append('search', s))
      if (params.page_size) searchParams.set('page_size', params.page_size.toString())
      if (params.page_number) searchParams.set('page_number', params.page_number.toString())
      queryString = searchParams.toString() ? `?${searchParams.toString()}` : ''
    }
    
    const data = await apiCall(`${ordersHref}${queryString}`)
    console.log('API returned data:', data)
    
    return data as OrdersListResponse
  },

  // HATEOAS-style: Get order details
  async getOrder(orderHref: string): Promise<Order> {
    const data = await apiCall(orderHref)
    return data as Order
  },

  // HATEOAS-style: Create order using clinic orders href
  async createOrder(ordersHref: string, orderData: CreateOrderRequest): Promise<Order> {
    const data = await apiCall(ordersHref, {
      method: 'POST',
      body: JSON.stringify(orderData),
    })
    return data as Order
  },
}